import React from 'react';
import { format } from 'date-fns';
import styles from '../css/vdr.module.css';
import FilingBanner from '../components/FilingBanner';
import { VDRFolderIcon } from '../components/VDRItemIcons';

const formatLastUpload = value => {
    if (!value) return null;
    try {
        return format(new Date(value), 'd MMM yyyy');
    } catch {
        return typeof value === 'string' ? value : null;
    }
};

const WorkstreamView = ({
    workstream,
    folders = [],
    fileCountsByFolder = {},
    lastUploadByFolder = {},
    onOpenFolder,
    onEditWorkstream,
    filingCount = 0,
    onReviewFiling,
}) => {
    const description = workstream?.description || '';

    const topFolders = (folders || []).filter(f => !f.parent && !f.parent_id);

    return (
        <>
            {filingCount > 0 && <FilingBanner count={filingCount} onReview={onReviewFiling} />}

            <div className={styles.contentHeader}>
                <div>
                    <h2 className={styles.contentTitle}>{workstream?.name || 'Workstream'}</h2>
                    {description ? <p className={styles.contentDesc}>{description}</p> : null}
                </div>
                <button type="button" className={styles.textLink} onClick={onEditWorkstream}>
                    Edit workstream
                </button>
            </div>

            <div className={styles.folderCards}>
                {topFolders.length === 0 && (
                    <div className={styles.emptyState}>No folders yet. Use Add new → Create folder.</div>
                )}
                {topFolders.map(folder => {
                    const count = fileCountsByFolder[folder.id] ?? 0;
                    const lastUpload = formatLastUpload(lastUploadByFolder[folder.id] || folder.last_upload || folder.updated_at);
                    const countLabel = count === 1 ? '1 item' : `${count} items`;
                    const sub = lastUpload ? `${countLabel} · Last upload ${lastUpload}` : countLabel;

                    return (
                        <div
                            key={folder.id}
                            className={styles.folderCard}
                            role="button"
                            tabIndex={0}
                            onClick={() => onOpenFolder?.(folder)}
                            onKeyDown={e => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    onOpenFolder?.(folder);
                                }
                            }}
                        >
                            <VDRFolderIcon />
                            <div className={styles.folderCardMeta}>
                                <p className={styles.folderCardTitle}>{folder.name}</p>
                                <p className={styles.folderCardSub}>{sub}</p>
                            </div>
                            <span className={styles.openLink}>Open →</span>
                        </div>
                    );
                })}
            </div>
        </>
    );
};

export default WorkstreamView;
